/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AppSchemasArbitratorCriterionInputSource = typeof AppSchemasArbitratorCriterionInputSource[keyof typeof AppSchemasArbitratorCriterionInputSource];


export const AppSchemasArbitratorCriterionInputSource = {
  auto: 'auto',
  manual: 'manual',
  ai_modified: 'ai_modified',
  preset: 'preset',
} as const;
